// @ts-nocheck
import * as React from "react";

const GlobeFill: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path
                d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zm0 2a8.19 8.19 0 011.79.21 2.61 2.61 0 01-.78 1c-.22.17-.46.31-.7.46a4.56 4.56 0 00-1.85 1.67 6.49 6.49 0 00-.62 3.3c0 1.36 0 2.16-.95 2.87-1.37 1.07-3.46.47-4.76-.07A8 8 0 0112 4zm4.89 14.32a6.79 6.79 0 00-.63-1.14c-.11-.16-.22-.32-.32-.49-.39-.68-.25-1 .38-2l.1-.17a4.77 4.77 0 00.58-2.43 5.42 5.42 0 01.09-1c.16-.73 1.71-.93 2.67-1a7.94 7.94 0 01-2.86 8.28l-.01-.05z"
                fill="currentColor"
                fillRule="evenodd"
                clipRule="evenodd"
            />
        </svg>
    );
};

export default React.memo(GlobeFill);
